document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-custom-faq-page]');
  const animationDuration = 260;
  const animationEasing = 'cubic-bezier(0.4, 0, 0.2, 1)';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setPanelState = (panel, isOpen, animate = true) => {
    const wasHidden = panel.hidden;
    const interruptedHeight = panel.faqAnimation
      ? panel.getBoundingClientRect().height
      : null;
    const interruptedPaddingBottom = panel.faqAnimation
      ? window.getComputedStyle(panel).paddingBottom
      : null;

    if (panel.faqAnimation) {
      panel.faqAnimation.cancel();
    }

    const expandedPaddingBottom = window.getComputedStyle(panel).paddingBottom;

    if (!animate || reduceMotion || typeof panel.animate !== 'function') {
      panel.hidden = !isOpen;
      panel.faqAnimation = null;
      return;
    }

    const startHeight = wasHidden
      ? 0
      : interruptedHeight ?? panel.getBoundingClientRect().height;
    const startPaddingBottom = wasHidden
      ? '0px'
      : interruptedPaddingBottom ?? expandedPaddingBottom;

    panel.hidden = false;

    const endHeight = isOpen ? panel.scrollHeight : 0;
    const animation = panel.animate(
      [
        {
          height: `${startHeight}px`,
          opacity: isOpen && startHeight === 0 ? 0 : 1,
          paddingBottom: startPaddingBottom,
        },
        {
          height: `${endHeight}px`,
          opacity: isOpen ? 1 : 0,
          paddingBottom: isOpen ? expandedPaddingBottom : '0px',
        },
      ],
      {
        duration: animationDuration,
        easing: animationEasing,
        fill: 'both',
      }
    );

    panel.faqAnimation = animation;

    animation.addEventListener('finish', () => {
      if (panel.faqAnimation !== animation) return;

      panel.hidden = !isOpen;
      animation.cancel();
      panel.faqAnimation = null;
    });
  };

  sections.forEach((section) => {
    const groups = section.querySelectorAll('[data-faq-group]');

    groups.forEach((group) => {
      const triggers = group.querySelectorAll('[data-faq-trigger]');

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const item = trigger.closest('[data-faq-item]');
          const panel = item ? item.querySelector('[data-faq-panel]') : null;
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';

          if (!item || !panel) return;

          const openItems = group.querySelectorAll('[data-faq-item].is-open');

          openItems.forEach((openItem) => {
            if (openItem === item) return;

            const openTrigger = openItem.querySelector('[data-faq-trigger]');
            const openPanel = openItem.querySelector('[data-faq-panel]');

            openItem.classList.remove('is-open');

            if (openTrigger) {
              openTrigger.setAttribute('aria-expanded', 'false');
            }

            if (openPanel) {
              setPanelState(openPanel, false);
            }
          });

          if (isOpen) {
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            setPanelState(panel, false);
            return;
          }

          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          setPanelState(panel, true);
        });
      });
    });
  });
});
